import { InsuranceCarrierService } from "../services/insuranceCarrierService";
import { GlobalStore, GridStore, ApiResponse } from "@roc/feature-app-core";
import { Option } from "@roc/ui/utils";
import { flow, makeObservable, observable, action } from "mobx";
import { InsuranceCarrierFormStore } from "./insuranceCarrierFormStore";


export class InsuranceCarrierStore {
  private globalStore: GlobalStore;
  protected insuranceCarrierService: InsuranceCarrierService;
  public insuranceCarrierGridStore: GridStore;
  public formStore: InsuranceCarrierFormStore;
  public insuranceCarrierOptions: Option[] = [];
  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.insuranceCarrierGridStore = new GridStore(() => this.fetchInsuranceCarriers(), null, 10);
    this.insuranceCarrierService = new InsuranceCarrierService();
    this.formStore = new InsuranceCarrierFormStore(globalStore);
    makeObservable(this, {
      insuranceCarrierGridStore: observable,
      insuranceCarrierOptions: observable,
      getInsuranceCarrierOptions: flow,
      fetchInsuranceCarriers: action,
      saveCarrier: flow,
      deleteCarrier: flow
    });
  }

  async fetchInsuranceCarriers() {
    try {

      const response: ApiResponse = await this.insuranceCarrierService.getInsuranceCarrierGrid(
        this.insuranceCarrierGridStore.gridData.meta.pageNumber,
        this.insuranceCarrierGridStore.gridData.meta.pageSize,
        this.insuranceCarrierGridStore.gridData.meta.sortDir,
        this.insuranceCarrierGridStore.gridData.meta.sortBy,
        this.insuranceCarrierGridStore.gridData.meta.filters
      );
      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error fetching insurance carriers',
      });
    }
  }

  *getInsuranceCarrierOptions() {
    try {
      const response = yield this.insuranceCarrierService.getInsuranceCarrierOptions()
      this.insuranceCarrierOptions = response.data.data;
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error fetching carriers',
      });
    }
  }

  *saveCarrier() {
    try {
      if (!this.formStore.runFormValidationWithMessage('Fill the required fields')) {
        return;
      }
      const response: ApiResponse = yield this.insuranceCarrierService.saveCarrier(this.formStore.getFormValues());
      if (response?.data?.error) {
        this.globalStore.notificationStore.showErrorNotification({
          message: response?.data?.error?.message
        });
        return;
      }
      this.formStore.setDialogState(null);
      this.insuranceCarrierGridStore.resetAndFetchGridData();
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error saving carrier',
      });
    }
  }

  *deleteCarrier() {
    try {
      yield this.insuranceCarrierService.deleteCarrier(this.formStore.getValue('insuranceCarrierId'));
      this.formStore.setDeleteDialogState(false);
      this.insuranceCarrierGridStore.resetAndFetchGridData();
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error deleting carrier',
      });
    }
  }
}